<template>
  <div>
    <v-dialog v-model="dialogData" persistent fullscreen v-show="dialogData">
        <div id="backgroundVideo"></div>
        <!-- Fondo de estrellas -->
        <div class="stars-background">
            <div 
                v-for="(star, index) in stars" 
                :key="index"
                class="star"
                :style="star.style"
            ></div>
        </div>

        <!-- Carritos -->
        <div class="trucks-container">
          <div style="position: relative; width: 100%; height: 100%;">
            <div
                v-for="(truck, index) in trucks"
                :key="index"
                class="truck-wrapper"
                :style="{ left: truck.left + 'px' }"
              >
                <div class="truck-body">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 198 93">
                        <path stroke-width="3" stroke="#282828" fill="#4CAF50" d="M135 22.5H177.264C178.295 22.5 179.22 23.133 179.594 24.0939L192.33 56.8443C192.442 57.1332 192.5 57.4404 192.5 57.7504V89C192.5 90.3807 191.381 91.5 190 91.5H135C133.619 91.5 132.5 90.3807 132.5 89V25C132.5 23.6193 133.619 22.5 135 22.5Z"></path>
                        <path stroke-width="3" stroke="#282828" fill="#FF9800" d="M146 33.5H181.741C182.779 33.5 183.709 34.1415 184.078 35.112L190.538 52.112C191.16 53.748 189.951 55.5 188.201 55.5H146C144.619 55.5 143.5 54.3807 143.5 53V36C143.5 34.6193 144.619 33.5 146 33.5Z"></path>
                        <rect stroke-width="3" stroke="#282828" fill="#DFDFDF" rx="2.5" height="90" width="121" y="1.5" x="6.5"></rect>
                    </svg>
                    <div class="mango-box"><img src="/static/SUNSHINE40_sp.png" alt="" width="70"></div>
                    <div class="mango-box-text">
                      <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">{{ truck.label }}</div>
                    </div>
                </div>
                <div class="truck-tires">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
                        <circle stroke-width="3" stroke="#282828" fill="#282828" r="13.5" cy="15" cx="15"></circle>
                        <circle fill="#DFDFDF" r="7" cy="15" cx="15"></circle>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
                        <circle stroke-width="3" stroke="#282828" fill="#282828" r="13.5" cy="15" cx="15"></circle>
                        <circle fill="#DFDFDF" r="7" cy="15" cx="15"></circle>
                    </svg>
                </div>
                <div :class="['road', { animated: !trucksReady }]"></div>
            </div>
          </div>
        </div>
        <div style="background-color: #000 !important; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; overflow: hidden; flex-direction: column; gap: 30px;">
            <div style="max-width: 450px; position: relative;" id="contentVideo">
                <div class="video-border"></div>
                <video
                    ref="videoPlayer"
                    autoplay
                    :src="videoSrc"
                    muted
                    class="video-content"
                ></video>
            </div>
            <div style="z-index: 100001; display: flex; justify-content: space-between; align-items: center; gap: 10px; position: fixed; bottom: 0px; left: 0; width: 100%; padding: 10px;">
                <v-btn color="success" class="play-button" @click="playVideo"><v-icon>mdi-repeat-variant</v-icon> Repetir</v-btn>
                <v-btn color="error" class="close-button" @click="closeDialog"><v-icon>mdi-close-circle-outline</v-icon> Cerrar</v-btn>
            </div>
        </div>
    </v-dialog>
  </div>
</template>

<script>
import { Fireworks } from 'fireworks-js';

export default {
  name: "AlertSunExpert5Years",
  props: {
    dialogData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoSrc: "/static/SunExpert5Years.mp4",
      stars: [],
      fireworksInstance: null,
      trucks: [],
      trucksReady: false,
      truckLabels: [
        "2020\nFundación",
        "2021\nExpansión",
        "2022-2023\nInnovación",
        "2024\nCrecimiento",
        "2025\nConsolidación"
      ],
    };
  },
  watch: {
    dialogData(val) {
      if (val) {
        console.log("dialogData", val);
        this.$nextTick(() => {
          const container = document.querySelector('#backgroundVideo');
          if (container) {
            this.fireworksInstance = new Fireworks(container, {
              autoresize: true,
              opacity: 0.5,
              acceleration: 1.4,
              friction: 0.97,
              gravity: 1.5,
              particles: 50,
              traceLength: 5,
              traceSpeed: 10,
              explosion: 10,
              intensity: 30,
              flickering: 50,
              lineStyle: 'round',
              hue: { min: 0, max: 360 },
              delay: { min: 20, max: 40 },
              rocketsPoint: { min: 50, max: 50 },
              lineWidth: {
                explosion: { min: 1, max: 3 },
                trace: { min: 1, max: 2 }
              },
              brightness: { min: 50, max: 80 },
              decay: { min: 0.015, max: 0.03 },
              mouse: { click: false, move: false, max: 1 }
            });
            this.fireworksInstance.start();

            setTimeout(() => {
              if (this.fireworksInstance) {
                this.fireworksInstance.stop();
                this.fireworksInstance = null;
              }
            }, 10000);
          }

          this.playVideo();
          this.generateStars();
          this.animateTrucks();
        });
      }
    }
  },
  methods: {
    closeDialog() {
      this.dialogData = false;
      this.$emit("close");
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      if (this.fireworksInstance) {
        this.fireworksInstance.stop();
        this.fireworksInstance = null;
      }

      localStorage.setItem("animate5Years", 0);
    },
    playVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        console.log("video", video);
        video.currentTime = 0;
        video.play();
      }
    },
    generateStars() {
      for (let i = 0; i < 100; i++) {
          this.stars.push({
              style: {
                  left: Math.random() * 100 + '%',
                  top: Math.random() * 100 + '%',
                  width: Math.random() * 3 + 1 + 'px',
                  height: Math.random() * 3 + 1 + 'px',
                  animationDelay: Math.random() * 2 + 's',
              }
          });
      }
    },
    animateTrucks() {
      const total = 5;
      const truckWidth = 150;
      const screenWidth = window.innerWidth;
      const totalSpacing = screenWidth - (total * truckWidth);
      const spacing = totalSpacing / (total + 1);
      const baseDuration = 6000; // duración total (ms)

      this.trucks = [];

      for (let i = 0; i < total; i++) {
        const finalLeft = spacing + i * (truckWidth + spacing);
        const initialLeft = -((total - i) * (truckWidth + 20)); // el primero más lejos

        this.trucks.push({
          left: initialLeft,
          finalLeft,
          delay: i * 200,
          label: this.truckLabels[i] || "" // asigna el texto
        });
      }

      this.$nextTick(() => {
        this.trucks.forEach((truck, i) => {
          setTimeout(() => {
            // Aplica transición dinámica según distancia a recorrer
            const distance = truck.finalLeft - truck.left;
            const duration = Math.max(1000, (distance / screenWidth) * baseDuration); // proporción a distancia

            const el = document.querySelectorAll('.truck-wrapper')[i];
            if (el) {
              el.style.transition = `left ${duration}ms ease-out`;
            }

            this.$set(this.trucks[i], 'left', truck.finalLeft);

            if (i === total - 1) {
              setTimeout(() => {
                this.trucksReady = true;
              }, duration + 200);
            }
          }, truck.delay);
        });
      });
    },
  },
};
</script>

<style>
#backgroundVideo{
  overflow: hidden;
  width: 99vw;
  height: 99vh;
}
#contentVideo {
  --radius-video: 50%;
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: var(--radius-video);
  /* overflow: hidden; */
  z-index: 100;
  transform: translateY(-80px);
}

.video-border {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border-radius: var(--radius-video);
  z-index: 100;
  /* box-shadow: 0px 0px 20px 0px rgb(255, 44, 11); */
}

.video-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  border-radius: var(--radius-video);
  object-fit: cover;
  display: block;
}

#backgroundVideo{
    position: absolute;
    top: 0;
    left: 0;
    width: 99vw;
    height: 99vh;
    z-index: 1;
    overflow: hidden;
}

/* Animación 2 */

.stars-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 99vw;
  height: 99vh;
  z-index: 1000;
}

.star {
  position: absolute;
  background: white !important;
  border-radius: 50%;
  animation: twinkle 2s infinite alternate;
  z-index: 1000;
}

@keyframes twinkle {
  0% { opacity: 0.3; transform: scale(1); }
  100% { opacity: 0.8; transform: scale(1.2); }
}

.trucks-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 150px;
  z-index: 10002;
}

/* .truck-wrapper {
  position: absolute;
  width: 150px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: visible;
}

.truck-wrapper.truck1 {
  bottom: 50px;
  left: 10px;
} */

.truck-wrapper {
  position: absolute;
  width: 150px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

@keyframes truckEnter {
  to {
    transform: translateX(0);
  }
}

.truck-body {
  width: 130px;
  height: fit-content;
  margin-bottom: 6px;
  animation: motion 1s linear infinite;
  position: relative;
}

@keyframes motion {
  0% { transform: translateY(0px); }
  50% { transform: translateY(3px); }
  100% { transform: translateY(0px); }
}

.truck-tires {
  width: 130px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 15px;
  position: absolute;
  bottom: 0;
}

.truck-tires svg {
  width: 24px;
  animation: spin 0.5s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.mango-box {
  position: absolute;
  top: 15px;
  left: 45px;
  transform: translateX(-50%);
  width: 80px;
  color: #333;
  padding: 4px;
  font-size: 10px;
  font-weight: bold;
}

.mango-box-text {
  position: absolute;
  top: -50px;
  left: 45px;
  transform: translateX(-50%);
  background: #FFD700;
  width: 80px;
  color: #333;
  padding: 4px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  border: 2px solid #FF9800;
  text-align: center;
  font-weight: bold;
}

.road {
  width: 100%;
  height: 2px;
  background-color: #555;
  position: absolute;
  bottom: 0;
  border-radius: 3px;
}

/* .road::before {
  content: "";
  position: absolute;
  width: 30px;
  height: 100%;
  background-color: #555;
  right: -10%;
  border-radius: 3px;
  border-left: 15px solid #FFD700;
}

.road.animated::before {
  animation: roadAnimation 2s linear infinite;
}

.road.stopped::before {
  animation: none !important;
  display: none;
} */

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.5); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes roadAnimation {
  0% { transform: translateX(0px); }
  100% { transform: translateX(-180px); }
}
</style>